<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش کارگروه</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>



			<div class="card card-style">
				<div class="content">
					<div class="input-style input-style-2 has-icon input-required mb-3">
						<i class="input-icon fa fa-check-square brand-color"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : workGroup.title!==null}">عنوان</span>
						<input class="form-control" type="text" v-model="workGroup.title">
					</div>
					<div>
						<div class="input-style input-style-2 has-icon input-required mb-3">
							<i class="input-icon fa fa-calendar brand-color"></i>
							<span class="color-highlight" :class="{'input-style-1-active' : workGroup.wFromDate!==null}">از تاریخ</span>
							<input class="text-left" type="text" v-model="workGroup.wFromDate" id="endDf" />
						</div>
						<date-picker type="date" v-model="workGroup.wFromDate" format="jYYYY/jMM/jDD" element="endDf" />
					</div>
					<div>
						<div class="input-style input-style-2 has-icon input-required mb-0">
							<i class="input-icon fa fa-calendar brand-color"></i>
							<span class="color-highlight" :class="{'input-style-1-active' : workGroup.wTillDate!==null}">تا تاریخ</span>
							<input class="text-left" type="text" v-model="workGroup.wTillDate" id="endDT" />
						</div>
						<date-picker type="date" v-model="workGroup.wTillDate" format="jYYYY/jMM/jDD" element="endDT" />
					</div>


					<div class="">
						<p class="p-2 text-justify mb-0 pt-0">
							در این لیست فقط
							<b class="text-danger">کابران دارای اشتراک</b>
							قابل مشاهده هستند. برای دسترسی به
							<b>لیست تمام کاربران</b>
							به قسمت
							<b class="text-danger">خرید اشتراک</b>
							مراجعه نمایید.
						</p>
						<div class="scrollableBox300">
							<div class="py-2 borderedListBox" v-for="user in LocalUserList" :key="user.userId">
								<div class="d-flex align-items-center justify-content-start">
									<input :checked="user.deleted" class="big-checkbox UserSelected" :name="user.personTitle" :userWorkGroupId="user.userWorkGroupId" type="checkbox" :value="user.userId" :id="user.userId" :key="user.userId" />
									<div class="w-100 pr-3">
										<div class="d-inline-flex align-items-center">
											<!--اگر کاربر تصویر پروفایل نداشت-->
											<!--<i class="fa fa-user color-magenta2-light ml-3"></i>-->
											<!--تصویر پروفایل کاربر-->
											<img v-if="user.userImg!=null && user.userImg!=''" :src="user.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-3 img-object-fit" />
											<i v-else  class="fa fa-user-circle color-magenta2-light ml-2 font-30"></i>
											<b>{{user.personTitle}}</b>
										</div>
									</div>
								</div>

							</div>
						</div>
						<div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
							<div class="spinner-border color-magenta2-dark" role="status"></div>
						</div>
					</div>
					<button :disabled="pageLoading" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="UpdateWorkGroup">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>
				</div>
			</div>
			<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
				<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
					<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import useVuelidate from '@vuelidate/core'
	import {
		required, between
	} from "@vuelidate/validators";
	import { maska } from 'maska';
	import DatePicker from 'vue3-persian-datetime-picker';
	import VueSimpleAlert from 'vue3-simple-alert';
	export default {
		components: {
			DatePicker
		},
		data() {
			return {
				title: "",
				pageLoading: true,
				workGroup: {
					workGroupId: 0,
					title: null,
					code: null,
					wFromDate: null,
					wTillDate: null,
					LocalUserWorkGroupJson: null,
					localUserWorkGroup: []
				},
				Users: [],
			}
		},
		methods: {
			UpdateWorkGroup() {
				if (this.workGroup.title == null || this.workGroup.title == "") {
					this.showErrorMessage("عنوان را وارد کنید");
					return;
				}
				let checkBox = document.getElementsByClassName("UserSelected");
				let userIds = [];
				let users = [];
				if (checkBox.length > 0) {
					for (var i = 0; i < checkBox.length; i++) {
						if (checkBox[i].checked) {
							userIds.push(checkBox[i].value);
						}
						let user = {
							Deleted: !userIds.includes(checkBox[i].value),
							UserId: checkBox[i].value,
							FromDate: "",
							TillDate: "",
							Disabled: false,
							UserWorkGroupId: checkBox[i].getAttribute("userWorkGroupId")
						};
						users.push(user);
					}
				}
				console.log(users);
				if (userIds.length == null || userIds.length <= 0) {
					this.showErrorMessage("هیچ کاربری انتخاب نشده است");
					return;
				}
				this.workGroup.localUserWorkGroup = users;
				this.pageLoading = true;
				this.$http.post("WorkGroup/Update", this.workGroup)
					.then(data => {
						this.pageLoading = false;
						var res = data.data;
						if (res.isSuccess) {
							this.showSuccessMessage(res.message);
                            setTimeout(function () { window.location.href = "/WorkGroupList"; }, 1500);
						} else {
							this.showErrorMessage(res.message);
						}
					});
			}

			, GetworkGroupUserList() {
				this.pageLoading = true;
				this.$http
					.get("WorkGroup/WorkGroupUsersList?id=" + this.workGroup.workGroupId)
					.then((data) => {
						var res = data.data;
						this.Users = res;
						this.pageLoading = false;
					});

			},
			GetworkGroupItem() {
				this.pageLoading = true;
				this.$http
					.get("WorkGroup/GetById?Id=" + this.workGroup.workGroupId)
					.then((data) => {
						var res = data.data;
						this.workGroup = res;
						this.title = "ویرایش کارگروه" + res.title;
						this.pageLoading = false;
					});

			},
		},
		computed: {
			LocalUserList() {
				return this.Users;
			},
		},
		created() {
			this.workGroup.workGroupId = this.$route.params.WorkGroupId;
			this.GetworkGroupItem();
			this.GetworkGroupUserList();

		},
		mounted() {
			this.pageLoading = false;
		},
		validations: {
			NoticeMassageUser: {
				ViewDate: {
					required,
				},
				ViewTime: {
					required
				},
				Title: {
					required
				}
			}
		},
		directives: { maska },
	}
</script>